import n from "js-cookie";
function g(e) {
  return e ? n.get(e) : n.get();
}
function c(e, t, l = 7, a = "/") {
  return n.set(e, t, { expires: l, path: a, domain: ".orangevip.com" });
}
function d(e, t = "/") {
  return n.remove(e, { path: t, domain: ".orangevip.com" });
}
function w(e) {
  e && e.split(",").forEach((l) => {
    let a = l.split("=");
    a[1] && c(a[0], a[1], 30);
  });
}
function O(e) {
  let t = decodeURIComponent(window.location.search).replace("?", "");
  (t !== "" ? t.split("&") : []).forEach((p) => {
    if (p) {
      const u = p.split("=");
      t = t.replace(u[0], u[0].toLowerCase());
    }
  });
  const a = new RegExp(`(^|&)${e.toLowerCase()}=([^&]*)(&|$)`), s = t.match(a);
  return s != null ? s[2] : "";
}
function R(e) {
  let t = encodeURIComponent(location.href);
  location.replace(`${e}?refer=${t}&before_from=\u767B\u5F55\u5931\u6548&wxsq=1`);
}
function v(e, t, l) {
  let a, s;
  return function() {
    const u = this, i = arguments;
    if (a && window.clearTimeout(a), l) {
      let h = !a;
      a = window.setTimeout(function() {
        a = void 0;
      }, t), h && (s = e.apply(u, i));
    } else
      a = window.setTimeout(function() {
        e.apply(u, i);
      }, t);
    return s;
  };
}
function U(e) {
  return /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/.test(e);
}
function M(e, t = location.href) {
  let l = new RegExp("(^|&)" + e + "=([^&]*)(&|$)", "i"), a = t.substring(t.indexOf("?")).substring(1).match(l);
  return a != null ? decodeURIComponent(decodeURI(a[2])) : null;
}
function C(e) {
  var t;
  return e = e ? e.toLowerCase() : navigator.userAgent.toLowerCase(), ((t = e.match(/MicroMessenger/i)) == null ? void 0 : t.toString()) == "micromessenger";
}
function L(e) {
  return e = e || navigator.userAgent, e.match(/chengla_android/i) ? !0 : !!e.match(/chengla_ios/i);
}
function b() {
  let e = document.documentElement.scrollTop || document.body.scrollTop;
  const t = setInterval(() => {
    document.body.scrollTop = document.documentElement.scrollTop = e -= 80, e <= 0 && clearInterval(t);
  }, 10);
}
function T(e = 32) {
  let t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678", l = t.length, a = "";
  for (let s = 0; s < e; s++)
    a += t.charAt(Math.floor(Math.random() * l));
  return a;
}
function E(e, t = "yyyy-mm-dd h:m:s") {
  let l = e.length === 10 ? e * 1e3 : e, a = new Date(l), s, p = new Map(s);
  p.set("yyyy", a.getFullYear()), p.set("mm", a.getMonth() + 1), p.set("dd", a.getDate()), p.set("h", a.getHours()), p.set("m", a.getMinutes()), p.set("s", a.getSeconds());
  for (let [u, i] of p.entries())
    t = t.replace(u, m(i));
  return t;
}
function m(e) {
  return (e < 10 ? "0" + e : e).toString();
}
function D() {
  return !!window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
}
function y() {
  return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}
function I(e) {
  return /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(e);
}
function k(e) {
  const t = /([0-9|*|#]\uFE0F\u20E3)|([0-9|#]\u20E3)|([\u203C-\u3299]\uFE0F\u200D)|([\u203C-\u3299]\uFE0F)|([\u2122-\u2B55])|(\u303D)|([(\A9)|(\AE)]\u3030)|(\uA9)|(\uAE)|(\u3030)|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF])|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F])/g;
  return e.replace(t, "");
}
const o = {
  kaifa: "t-",
  test: "test-",
  alpha: "alpha-",
  production: "",
  dev: "-1"
}, r = (e, t, l = "production") => o[l] != "-1" ? `https://${o[l]}${t}.orangevip.com` : e, x = (e, t = "production") => o[t] != "-1" ? `https://${o[t]}${e}.orangevip.com` : `https://t-${e}.orangevip.com`, S = (e, t = "production") => (e.url.includes("/JAVAOTM") ? (e.url = e.url.replace("/JAVAOTM", ""), e.baseURL = r("/JAVAOTM", "clapp", t)) : e.url.includes("otm/h5") || e.url.includes("otm/web") ? e.baseURL = r("/JAVAOTM", "clapp", t) : e.url.includes("/uCenterApi") ? (e.url = e.url.replace("/uCenterApi", ""), e.baseURL = r("/uCenterApi", "u.api", t)) : e.url.includes("/Docs") ? (e.url = e.url.replace("/Docs", ""), e.baseURL = r("/Docs", "docs", t)) : e.url.includes("/shopApi") ? (e.url = e.url.replace("/shopApi", ""), e.baseURL = r("/shopApi", "shopapi", t)) : e.url.includes("/TIKU") ? (e.url = e.url.replace("/TIKU", ""), e.baseURL = r("/TIKU", "tiku", t)) : e.url.includes("/COMMENT") ? (e.url = e.url.replace("/COMMENT", ""), e.baseURL = r("/COMMENT", "comment", t)) : e.url.includes("/CMS") ? (e.url = e.url.replace("/CMS", ""), e.baseURL = r("/CMS", "cms", t)) : e.url.includes("/OTMADMIN") ? (e.url = e.url.replace("/OTMADMIN", ""), e.baseURL = r("/OTMADMIN", "otmadmin", t)) : e.url.includes("/platform") ? (e.url = e.url.replace("/platform", ""), e.baseURL = r("/platform", "platform", t)) : e.url.includes("/TGPHP") ? (e.url = e.url.replace("/TGPHP", ""), e.baseURL = r("/TGPHP", "tg", t)) : e.url.includes("/WORD") ? (e.url = e.url.replace("/WORD", ""), e.baseURL = r("/WORD", "word", t)) : e.url.includes("/toolsApi") ? (e.url = e.url.replace("/toolsApi", ""), e.baseURL = r("/toolsApi", "tools", t)) : e.url.includes("/phpCrm") ? (e.url = e.url.replace("/phpCrm", ""), e.baseURL = r("/phpCrm", "crm", t)) : e.url.includes("/phpupload") || e.url.includes("upload.php") ? (e.url.indexOf("/phpupload") >= 0 && (e.url = e.url.replace("/phpupload", "")), e.baseURL = r("/FILES", "f", t)) : e.url.includes("/OMS") ? (e.url = e.url.replace("/OMS", ""), e.baseURL = r("/OMS", "oms", t)) : (e.url.includes("/whale") || e.url.includes("/jtApi")) && (e.url.includes("/jtApi") && (e.url = e.url.replace("/jtApi", "")), e.baseURL = r("/WHALE", "whaleswallowapi", t)), e), F = {}, N = {
  "/JAVAOTM": {
    target: "https://t-clapp.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/JAVAOTM": ""
    }
  },
  "/uCenterApi": {
    target: "https://t-u.api.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/uCenterApi": ""
    }
  },
  "/shopApi": {
    target: "https://t-shopapi.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/shopApi": ""
    }
  },
  "/TIKU": {
    target: "https://t-tiku.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/TIKU": ""
    }
  },
  "/Docs": {
    target: "https://t-docs.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/Docs": ""
    }
  },
  "/COMMENT": {
    target: "https://t-comment.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/COMMENT": ""
    }
  },
  "/CMS": {
    target: "https://t-cms.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/CMS": ""
    }
  },
  "/OTMADMIN": {
    target: "https://t-otmadmin.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/OTMADMIN": ""
    }
  },
  "/platform": {
    target: "https://t-platform.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/platform": ""
    }
  },
  "/TGPHP": {
    target: "https://t-tgphp.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/TGPHP": ""
    }
  },
  "/WORD": {
    target: "https://t-word.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/WORD": ""
    }
  },
  "/toolsApi": {
    target: "https://t-tools.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/toolsApi": ""
    }
  },
  "/phpCrm": {
    target: "https://t-crm.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/phpCrm": ""
    }
  },
  "/FILES": {
    target: "https://t-f.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/FILES": ""
    }
  },
  "/OMS": {
    target: "https://t-oms.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/OMS": ""
    }
  },
  "/WHALE": {
    target: "https://t-whaleswallowapi.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/WHALE": ""
    }
  }
}, W = (e, t = "production") => {
}, G = (e, t = "production") => (e.url.includes("/yxkApi") ? (e.url = e.url.replace("/yxkApi", ""), e.baseURL = r("/yxkApi", "yxkapi", t)) : e.url.includes("/APPLE") ? (e.url = e.url.replace("/APPLE", ""), e.baseURL = r("/APPLE", "apple", t)) : e.url.includes("/MANGO/") ? (e.url = e.url.replace("/MANGO", ""), e.baseURL = r("/MANGO", "mango", t)) : e.url.includes("/Docs") ? (e.url = e.url.replace("/Docs", ""), e.baseURL = r("/Docs", "docs", t)) : e.url.includes("/clUApi") ? (e.url = e.url.replace("/clUApi", ""), e.baseURL = r("/clUApi", "u.api", t)) : e.url.includes("/phpupload") ? (e.url.includes("/phpupload") && (e.url = e.url.replace("/phpupload", "")), e.baseURL = r("/files", "f", t)) : e.url.includes("/TIKU") ? (e.url = e.url.replace("/TIKU", ""), e.baseURL = r("/TIKU", "tiku", t)) : e.url.includes("/assetsApi") ? (e.url = e.url.replace("/assetsApi", ""), e.baseURL = r("/assetsApi", "assets", t)) : e.url.includes("/orgApi") ? (e.url = e.url.replace("/orgApi", ""), e.baseURL = r("/orgApi", "auth", t)) : e.url.includes("/classapi/") || e.url.includes("/CApi") ? (e.url.includes("/CApi") && (e.url = e.url.replace("/CApi", "")), e.baseURL = r("/CApi", "divisionclass", t)) : (e.url.includes("/whale") || e.url.includes("/jtApi")) && (e.url.includes("/jtApi") && (e.url = e.url.replace("/jtApi", "")), e.baseURL = r("/WHALE", "whaleswallowapi", t)), e), H = {
  "/files": {
    target: "https://t-f.orangevip.com",
    changeOrigin: !0,
    rewrite: (e) => e.replace(/^\/files/, "")
  },
  "/clUApi": {
    target: "https://t-u.api.orangevip.com",
    changeOrigin: !0,
    rewrite: (e) => e.replace(/^\/clUApi/, "")
  },
  "/assetsApi": {
    target: "https://t-assets.orangevip.com",
    changeOrigin: !0,
    rewrite: (e) => e.replace(/^\/assetsApi/, "")
  },
  "/Docs": {
    target: "https://t-docs.orangevip.com",
    changeOrigin: !0,
    rewrite: (e) => e.replace(/^\/Docs/, "")
  },
  "/CApi": {
    target: "https://t-divisionclass.orangevip.com",
    changeOrigin: !0,
    rewrite: (e) => e.replace(/^\/CApi/, "")
  },
  "/yxkApi": {
    target: "https://t-yxkapi.orangevip.com",
    changeOrigin: !0,
    rewrite: (e) => e.replace(/^\/yxkApi/, "")
  },
  "/APPLE": {
    target: "https://t-apple.orangevip.com",
    changeOrigin: !0,
    rewrite: (e) => e.replace(/^\/APPLE/, "")
  },
  "/MANGO": {
    target: "https://t-mango.orangevip.com",
    changeOrigin: !0,
    rewrite: (e) => e.replace(/^\/MANGO/, "")
  },
  "/WHALE": {
    target: "https://t-whaleswallowapi.orangevip.com",
    changeOrigin: !0,
    rewrite: (e) => e.replace(/^\/WHALE/, "")
  },
  "/orgApi": {
    target: "https://t-auth.orangevip.com",
    changeOrigin: !0,
    rewrite: (e) => e.replace(/^\/orgApi/, "")
  },
  "/TIKU": {
    target: "https://t-tiku.orangevip.com",
    changeOrigin: !0,
    rewrite: (e) => e.replace(/^\/TIKU/, "")
  }
}, K = {
  "/files": {
    target: "https://t-f.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/files": ""
    }
  },
  "/clUApi": {
    target: "https://t-u.api.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/clUApi": ""
    }
  },
  "/assetsApi": {
    target: "https://t-assets.api.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/assetsApi": ""
    }
  },
  "/Docs": {
    target: "https://t-docs.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/Docs": ""
    }
  },
  "/CApi": {
    target: "https://t-divisionclass.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/CApi": ""
    }
  },
  "/yxkApi": {
    target: "https://t-yxkapi.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/yxkApi": ""
    }
  },
  "/APPLE": {
    target: "https://t-apple.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/APPLE": ""
    }
  },
  "/MANGO": {
    target: "https://t-mango.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/MANGO": ""
    }
  },
  "/WHALE": {
    target: "https://t-whaleswallowapi.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/WHALE": ""
    }
  },
  "/orgApi": {
    target: "https://t-auth.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/orgApi": ""
    }
  },
  "/TIKU": {
    target: "https://t-tiku.orangevip.com",
    changeOrigin: !0,
    pathRewrite: {
      "^/TIKU": ""
    }
  }
};
export {
  m as addZero,
  E as dateFormat,
  v as debounce,
  g as getCookie,
  O as getQueryString,
  M as getUrlParamItem,
  R as goLogin,
  b as goToTop,
  L as isClApp,
  I as isEmail,
  y as isIOS,
  D as isMobileDevice,
  U as isPhoneNum,
  C as isWeiXin,
  o as linkObject,
  T as random_string,
  d as removeCookie,
  k as replaceEmo,
  G as setAdminConfig,
  H as setAdminProxy,
  K as setAdminWebPackProxy,
  r as setBaseUrl,
  S as setConfig,
  c as setCookie,
  w as setCookieForWxapp,
  x as setGoToUrl,
  W as setNuxtConfug,
  F as setProxy,
  N as setWebPackProxy
};
//# sourceMappingURL=index.mjs.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chengla_web/cl_newutil/dist/index.mjs
// module id = VVR3
// module chunks = 31